import React from "react"
import styled, { StyledComponent } from "styled-components"

const PanelSection: StyledComponent<
  "section",
  any,
  { marginTop?: string | undefined; contentPaddingTop?: number | undefined },
  never
> = styled.section`
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  ${({
    marginTop,
    contentPaddingTop,
  }: {
    marginTop?: string | undefined
    contentPaddingTop?: number | undefined
  }) => marginTop && "margin-top: " + marginTop + ";"}
  padding-bottom: 20px;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    background: transparent;
    border-bottom: 1px solid #f0f0f0;
    padding: 12px 20px;
  }

  .hidden {
    display: none;
  }

  header h2 {
    color: #1f1f1f;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.3;
    padding: 0;
    margin: 0;
    text-transform: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

   .panel-header-main {
    min-width: 0;
    flex: 1 1 auto;
  }

  .panel-header-actions {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .content {
    padding: 16px 20px;
    width: 100%;
    padding-top: ${({
      marginTop,
      contentPaddingTop,
    }: {
      marginTop?: string | undefined
      contentPaddingTop?: number | undefined
    }) => (contentPaddingTop === undefined ? "15" : `${contentPaddingTop}`)}px;
  }

  @media (max-width: 576px) {
    header {
      padding: 10px 14px;
    }

    .content {
      padding: 12px 14px;
    }
  }
`

export default function ContentPanel({
  title,
  headerActions,
  children,
  marginTop,
  contentPaddingTop,
}: {
  title?: string | JSX.Element
  headerActions?: React.ReactNode
  children: React.ReactNode
  marginTop?: string
  contentPaddingTop?: number
}): JSX.Element {
  return (
    <PanelSection marginTop={marginTop} contentPaddingTop={contentPaddingTop}>
      {title !== undefined ? (
        <header>
          <div className="panel-header-main">
            <h2>{title}</h2>
          </div>
          {headerActions ? (
            <div className="panel-header-actions">{headerActions}</div>
          ) : null}
        </header>
      ) : null}
      <div className={children !== null ? "content" : "hidden"}>{children}</div>
    </PanelSection>
  )
}
